import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { AppComponent } from './app.component';
import { VendorShellModule } from '@viso/web/vendor/shell';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {
  AuthInterceptorService,
  ENVIRONMENT,
  ErrorHandlerService,
  UserService,
  AuthService,
  BUILD_INFO,
  AuthGuardHelper,
} from '@viso/core/data-access';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

import { OnlineStatusModule } from '@viso/core/ui/online-status';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { options } from '@viso/core/constants';
import * as buildInfo from './../build-info.json';
import { AuthGuardRoutes } from '@viso/core/models';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { GlobalInjector } from '@viso/core/utilities';
const socketConfig: SocketIoConfig = {
  url: environment.SOCKET_URL,
  options: {},
};

const ionicConfig = {
  ...options,
};

export function UserInfo(userService: UserService, auth: AuthService) {
  return (): Promise<any> => {
    const isLoggedIn = auth.isLoggedIn();
    if (isLoggedIn) {
      return userService.getUser().toPromise();
    } else {
      return Promise.resolve();
    }
  };
}

export const AuthGuardHelperRoutes: AuthGuardRoutes = {
  anonymousRoutes: [
    'login',
    'welcome',
    'register',
    'registration-details',
    'privacy-policy',
    'terms-and-conditions',
    'help',
  ],
  beforeLoginDefaultRoute: ['welcome'],
  afterLoginDefaultRoute: ['/event/list'],
  beforeAndAfterLoginPermittedRoute: [],
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        VendorShellModule,
        OnlineStatusModule,
        IonicModule.forRoot(ionicConfig),
        ServiceWorkerModule.register('/ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        HttpClientModule,
        SocketIoModule.forRoot(socketConfig),
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireAuthModule,
    ],
    providers: [
        StatusBar,
        SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: ENVIRONMENT, useValue: environment },
        { provide: BUILD_INFO, useValue: buildInfo['default'] },
        { provide: AuthGuardHelper, useValue: AuthGuardHelperRoutes },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: UserInfo,
            deps: [UserService, AuthService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerService,
            multi: true,
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    GlobalInjector.injector = injector;
  }
}
